import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

interface StyledBoxProps {
  layoutHeight?: number;
  smallLayoutHeight?: number;
}

export const StyledBox = styled(Box)<StyledBoxProps>(
  ({ theme, layoutHeight, smallLayoutHeight }) => ({
    paddingTop: `calc(${theme.spacing(layoutHeight)} + ${theme.spacing(6)})`,
    [theme.breakpoints.down('md')]: {
      paddingTop: `calc(${theme.spacing(smallLayoutHeight)} + ${theme.spacing(
        3,
      )})`,
    },

    '& .HSCoverContainer': {
      width: '100%',
      height: theme.typography.pxToRem(900),
      marginTop: theme.spacing(4),
      [theme.breakpoints.down('lg')]: {
        height: theme.typography.pxToRem(600),
      },
      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(3),
        height: theme.typography.pxToRem(239),
      },
    },
    '& .HSContainer': {
      width: '100%',
    },
    '& .HSHeaderGrid': {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.typography.pxToRem(16),
      [theme.breakpoints.down('md')]: {
        gap: theme.typography.pxToRem(16),
      },
    },
    '& .HSBreadcrumbWrapper': {
      marginBottom: 0,
      '& .HSBackLink': {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.typography.pxToRem(8),
        textDecoration: 'none',
        color: theme.palette.common.white,
        transition: 'opacity 0.3s ease',
        textTransform: 'none !important',
        '& .HSBackLinkIcon': {
          fontSize: theme.typography.pxToRem(16),
          flexShrink: 0,
          color: theme.palette.common.white,
          position: 'relative',
          top: theme.typography.pxToRem(-2),
        },
        '& .HSBackLinkText': {
          textTransform: 'none !important',
          textDecoration: 'none',
          fontSize: theme.typography.pxToRem(15),
          fontWeight: 600,
          color: theme.palette.common.white,
        },
      },
    },
    '& .HSTitleDateWrapper': {
      display: 'flex',
      gap: theme.spacing(8),
      [theme.breakpoints.down('md')]: {
        alignItems: 'flex-start',
        gap: theme.spacing(2),
      },
      '& .HSTitle': {
        [theme.breakpoints.down('md')]: {
          fontSize: theme.typography.pxToRem(16),
          lineHeight: '140%',
        },
      },
    },
    '& .HSTitleContainer': {
      display: 'flex',
      marginRight: 'auto',
      flexDirection: 'column',
      gap: theme.spacing(2),
      flex: 1,
      minWidth: 0,
    },
    '& .HSDateWrapper': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      '& .HSDateIcon': {
        fontSize: theme.typography.pxToRem(18),
        color: theme.palette.text.secondary,
        position: 'relative',
        top: theme.typography.pxToRem(-2),
      },
    },
  }),
);

export default StyledBox;
